(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("component-emitter"), require("mailoop-keen-core"));
	else if(typeof define === 'function' && define.amd)
		define(["component-emitter", "mailoop-keen-core"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("component-emitter"), require("mailoop-keen-core")) : factory(root["component-emitter"], root["mailoop-keen-core"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(global, function(__WEBPACK_EXTERNAL_MODULE__22__, __WEBPACK_EXTERNAL_MODULE__23__) {
return 